import React from 'react';
import styled from 'styled-components';

import constants from 'utils/constants';
import { formatPriceByLocale } from 'utils/utils';

export default function OrderItem({
  isChallenge,
  bannerImg, 
  title, 
  optionName, 
  unitPrice,
  quantity, 
  challengeUnitPrice 
}) {
  const refundPrice = unitPrice - challengeUnitPrice;
  return (
    <OrderItemBlock>
      <Left>
        <OrderItemImg src={`${constants.imagePath}/commerce/product/banner_img/${bannerImg}`}/>
      </Left>
      <Right>
        <ProductTitle>{title}</ProductTitle>
        <OptionName>{optionName}</OptionName>
        <UnitPriceQuantity>
          <UnitPrice>{`${formatPriceByLocale('ko', unitPrice)}원`}</UnitPrice>
          <Quantity>{`${quantity}개`}</Quantity>
        </UnitPriceQuantity>
        {isChallenge && (
          <RefundPrice>{`성공시 ${formatPriceByLocale('ko', refundPrice)}원 환급`}</RefundPrice>
        )}
      </Right>
    </OrderItemBlock>
  )
}

const OrderItemBlock = styled.div`
  display: flex;
  margin-bottom: calc(100vw * (16 / 375));
  &:last-child {
    margin-bottom: 0;
  }
  /* & + & {
    margin-bottom: calc(100vw * (16 / 375));
  } */
`;

const Left = styled.div`
  flex: 0 1 auto;
  width: calc(100vw * (89 / 375));
  height: calc(100vw * (89 / 375));
  border-radius: calc(100vw * (6 / 375));
  overflow: hidden;
  margin-right: calc(100vw * (14 / 375));
`;

const OrderItemImg = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
`;

const Right = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
`;

const ProductTitle = styled.span`
  font-size: calc(100vw * (14 / 375));
  font-weight: 600;
  line-height: calc(100vw * (17 / 375));
  color: #121212;
  margin-bottom: calc(100vw * (5/  375));
`;

const OptionName = styled.span`
  font-size: calc(100vw * (12 / 375));
  font-weight: 500;
  line-height: calc(100vw * (14.4 / 375));
  color: #7F7F7F;
  margin-bottom: calc(100vw * (9/  375));
`;

const UnitPriceQuantity = styled.div`
  font-size: calc(100vw * (14 / 375));
  line-height: calc(100vw * (16.8 / 375));
  margin-bottom: calc(100vw * (4 / 375));
`;

const UnitPrice = styled.span`
  font-weight: 700;
  color: #121212;
  margin-right: calc(100vw * (5 / 375));
`;

const Quantity = styled.span`
  font-weight: 500;
  color: #7F7F7F;
  border-left: 1px solid #7F7F7F;
  padding-left: calc(100vw * (5 / 375));
`;

const RefundPrice = styled.span`
  font-size: calc(100vw * (16 / 375));
  font-weight: 700;
  line-height: calc(100vw * (19.2 / 375));
  color: #FF6B00;
`;
